// src/App.js
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import RequireAuth from "./components/RequireAuth";
import SessionWarningBanner from "./components/SessionWarningBanner";

import LandingPage from "./components/LandingPage";
import Login from "./components/Login";
import Register from "./components/Register";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import VerifyEmail from "./components/VerifyEmail";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Dashboard from "./components/Dashboard";
import SendMoney from "./components/SendMoney";
import Profile from "./components/Profile";
import RecipientsPage from "./pages/RecipientsPage";
import KYCVerification from "./components/KYCVerification";
import PhoneVerification from "./components/PhoneVerification";
import UnlockCredit from "./components/UnlockCredit";
import TopUpAirtime from "./components/TopUpAirtime";
import CreateOrder from "./components/CreateOrder";

import CockpitLogin from "./cockpit/pages/CockpitLogin";
import RequireCockpitAuth from "./cockpit/RequireCockpitAuth";
import CockpitLayout from "./cockpit/CockpitLayout";
import CockpitDashboard from "./cockpit/pages/CockpitDashboard";
import CockpitTransactions from "./cockpit/pages/CockpitTransactions";
import CockpitCollections from "./cockpit/pages/CockpitCollections";
import CockpitCompliance from "./cockpit/pages/CockpitCompliance";
import CockpitKYC from "./cockpit/pages/CockpitKYC";
import CockpitProviders from "./cockpit/pages/CockpitProviders";
import CockpitAudit from "./cockpit/pages/CockpitAudit";
import CockpitTeam from "./cockpit/pages/CockpitTeam";
import CockpitFXConfig from "./cockpit/pages/CockpitFXConfig";
import CockpitWallets from "./cockpit/pages/CockpitWallets";
import CockpitSNPLDecisions from "./cockpit/pages/CockpitSNPLDecisions";

function App() {
  return (
    <Router>
      <AuthProvider>
        <SessionWarningBanner />
        <Routes>
          {/* Public Customer Routes */}
          <Route path="/"         element={<LandingPage />} />
          <Route path="/login"    element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms"    element={<Terms />} />
          <Route path="/privacy"  element={<Privacy />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Customer Routes */}
          <Route element={<RequireAuth />}>
            <Route path="/dashboard"  element={<Dashboard />} />
            <Route path="/unlock-credit" element={<UnlockCredit />} />
            <Route path="/send"       element={<SendMoney />} />
            <Route path="/profile"    element={<Profile />} />
            <Route path="/recipients" element={<RecipientsPage />} />
            <Route path="/kyc" element={<KYCVerification />} />  
            <Route path="/verify-phone" element={<PhoneVerification />} />
            <Route path="/airtime" element={<TopUpAirtime />} />
	    <Route path="/create-order" element={<CreateOrder />} />	
          </Route>

          {/* Cockpit Login (public) */}
          <Route path="/cockpit/login" element={<CockpitLogin />} />

          {/* Cockpit (protected) */}
          <Route element={<RequireCockpitAuth />}>
            <Route path="/cockpit" element={<CockpitLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard"    element={<CockpitDashboard />} />
              <Route path="transactions" element={<CockpitTransactions />} />
              <Route path="collections"  element={<CockpitCollections />} />
              <Route path="snpl-decisions" element={<CockpitSNPLDecisions />} />
              <Route path="compliance"   element={<CockpitCompliance />} />
              <Route path="kyc"          element={<CockpitKYC />} />
              <Route path="providers"    element={<CockpitProviders />} />
              <Route path="audit"        element={<CockpitAudit />} />
              <Route path="team"         element={<CockpitTeam />} />
              <Route path="fx-config"    element={<CockpitFXConfig />} />
              <Route path="wallets"      element={<CockpitWallets />} />
            </Route>
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
